import { http } from "../../utils/http";

// Interface

export interface RegisterPayloadType {
  accountType: string;
  password: string;
  email: string;
  extension: Extension;
}

export interface Extension {
  organization: string;
  province: string;
}

export interface LoginPayloadType {
  grant_type: string;
  accountType: string;
  username: string;
  password: string;
}

export interface SentEmailVerifyType {
  email: string;
  url: string;
}

export interface EmailVerifyType {
  email: string;
  code: string;
}

export interface GetAccessTokenType {
  grant_type: string;
  refresh_token: string;
}

export interface ChangeGroupAPIType {
  userId: string;
}

// end Interface

export const CreateNewUser = (payload: RegisterPayloadType) => {
  return http.post(
    `/core/api/managements/1.0/account/register`,
    payload,
    false,
    false
  );
};

export const UserLogin = (payload: LoginPayloadType) => {
  return http.post(`/core/api/managements/1.0/login`, payload, false, true);
};

export const SentEmailVerify = (payload: SentEmailVerifyType) => {
  return http.post(
    `/core/api/managements/1.0/email/confirm`,
    payload,
    false,
    false
  );
};

export const VerifyEmailAPI = (payload: EmailVerifyType) => {
  return http.post(
    `/core/api/managements/1.0/email/verify`,
    payload,
    false,
    false
  );
};

export const GetAllProvidersIDP = () => {
  return http.get(
    `/core/api/managements/1.0/identity-providers`,
    undefined,
    false
  );
};

export const ChangeGroupAPI = (paylad: ChangeGroupAPIType) => {
  return http.post(`api/1.0/hotspots/changegroup`, paylad, true, false);
};

export const GetAccessToken = (payload: GetAccessTokenType) => {
  return http.post(`/core/api/managements/1.0/token`, payload, false, true);
};

export const LogoutAPI = () => {
  return http.post(`/core/api/managements/1.0/logout`, undefined, true, false);
};

export const UserGateways = (scope: string) => {
  return http.get(
    `/core/api/managements/1.0/account/application-accesses/scopes?scope=${scope}`,
    undefined,
    true
  );
};
